import { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HeroManParallax from "./parallax/HeroManParallax";

function TaxFilingHero() {
  const [dynamicText, setDynamicText] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  // const dynamicPhrases = [
  //   "designed around your situation",
  //   "guided by real experts",
  //   "done right, from start to finish.",
  // ];

  const dynamicPhrases = [];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false); // Start fade out
      setTimeout(() => {
        setDynamicText((prev) => (prev + 1) % dynamicPhrases.length);
        setIsVisible(true); // Start fade in
      }, 500); // Wait for fade out before changing text
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="classic-landing-hero">
      <div className="classic-landing-hero-content">
        <div className="classic-landing-hero-content-left">
          {/* 1. Dynamic header */}
          <h1 className="hero-header">
            <span className="hero-header-static">
              File your taxes with confidence
            </span>
            <span
              className={`hero-header-dynamic ${
                isVisible ? "visible" : "hidden"
              }`}
            >
              {dynamicPhrases[dynamicText]}
            </span>
          </h1>

          {/* 2. Description */}
          <p className="hero-description">
            Get matched with a licensed tax professional, upload your documents,
            and review everything before filing. Clear, intentional, and
            transparent.
          </p>

          {/* 3. Three list elements */}
          <ul className="hero-list">
            <li className="hero-list-item">
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/workspace_premium_light_blue.svg`}
                alt=""
                className="hero-list-icon"
              />
              <span>Licensed tax professionals</span>
            </li>
            <li className="hero-list-item">
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/redeem_light_blue.svg`}
                alt=""
                className="hero-list-icon"
              />
              <span>Deductions reviewed with expert care</span>
            </li>
            <li className="hero-list-item">
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/approval_delegation_light_blue.svg`}
                alt=""
                className="hero-list-icon"
              />
              <span>You approve before we file</span>
            </li>
          </ul>

          {/* 4. Two CTAs */}
          <div className="hero-cta-container">
            <Link to="/sign-up" className="cta-button primary">
              Start Filing
            </Link>
            <Link to="/sign-in" className="cta-button secondary">
              Sign In
            </Link>
          </div>
        </div>
        <div className="classic-landing-hero-content-right">
          <HeroManParallax />
        </div>
      </div>
    </section>
  );
}

export default TaxFilingHero;
